export const Colors = {
  primary: "rgb(0, 171, 85)",
};
